export default __webpack_public_path__ + "static/media/guarantorForm.f241939b.pdf";